import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import { validateGeo, validateZipCode } from '../utils/queries';
export default () => {
  const client = useApolloClient();
  const validateZip = useCallback(async zipcode => {
    if (zipcode && zipcode.length === 5) {
      try {
        const {
          data: {
            locationInfoByZip
          }
        } = await client.query({
          query: validateZipCode,
          variables: {
            zipcode
          }
        });
        if (locationInfoByZip) {
          return {
            zipcode,
            zipcodeValid: locationInfoByZip.isValid,
            zipcodeError: !locationInfoByZip.isValid,
            zipcodeInfo: locationInfoByZip
          };
        }
      } catch (err) {}
      return {
        zipcode,
        zipcodeValid: false,
        zipcodeError: true,
        zipcodeInfo: {}
      };
    }
  }, [client]);
  const validateGeolocation = useCallback(async ({
    latitude,
    longitude
  }) => {
    const {
      data: {
        locationInfoByLatLng
      }
    } = await client.query({
      query: validateGeo,
      variables: {
        latitude,
        longitude
      }
    });
    return locationInfoByLatLng;
  }, [client]);
  const customZipcodeValidator = useCallback(async el => {
    const result = await validateZip(el.value);
    return result && result.zipcodeValid;
  }, [validateZip]);
  return {
    validateZip,
    validateGeolocation,
    customZipcodeValidator
  };
};